<template>
  <topbar
    :titulo="$t('ACADEMICO.DOCENTES_PERIODO')"
    :subtitulo="$t('ACADEMICO.DOCENTES_DO_PERIODO_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  >
    <template #header>
      <div class="d-flex justify-content-between ml-4">
        <div></div>
        <b-button @click="irPara('funcionarios')" variant="info" class="mr-2">
          {{ $t('ACADEMICO.TODOS_PROFESSORES') }}
        </b-button>
      </div>
    </template>
  </topbar>
</template>
  <script>
// Utils & Aux:
import rotas from '@/common/utils/rotas';
import Topbar from '@/layouts/full-layout/horizontal-sidebar/Topbar.vue';

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t('ACADEMICO_HOME.PAINEL_ACADEMICO') },
        { titulo: this.$t('ACADEMICO.DOCENTES_PERIODO') },
      ],
    };
  },
  methods: {
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
  },
};
</script>
  